import React from 'react';
import PropTypes from 'prop-types';
import { withCookies } from 'react-cookie';
import { withRouter } from "react-router-dom";
import { withLocalize } from "react-localize-redux";
import { IconButton, MenuList, MenuItem, Popper, Grow, Paper, ClickAwayListener,Tooltip } from '@material-ui/core';
import { Language } from "@material-ui/icons";
import {setCookie} from "../../../reducers/userExport";
import {isMobile} from "../../../api/index";


class MenuLanguage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            auth: true,
            open: false,
        };
    }

    handleToggle = () => {
        this.setState(state => ({ open: !state.open }));
    };


    handleClose = () => {
        this.setState({ open: false });
    };


    handleClick(language) {
        let { setActiveLanguage } = this.props;
        setCookie("language",language);
        setActiveLanguage(language)
        //this.props.dispatchSetActiveLanguage(language);
        this.setState({ open: false });
    }

    

    render() {
        let { languages } = this.props;
        let { open } = this.state;

        return (
            <div>
                <Tooltip id="t1" title={!this.state.open && !isMobile() ?'idioma':''} >
                <IconButton color="secondary"
                    buttonRef={node => {
                        this.anchorEl = node;
                    }}
                    aria-owns={open ? 'menu-list-grow' : undefined}
                    aria-haspopup="true"
                    onClick={this.handleToggle}
                >
                    <Language />
                </IconButton>
                </Tooltip>                              
               
                <Popper open={open} anchorEl={this.anchorEl} style={{ zIndex: 2 }} transition disablePortal>
                    {({ TransitionProps, placement }) => (
                        <Grow
                            {...TransitionProps}
                            id="menu-list-grow"
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                        >
                            <Paper>
                                <ClickAwayListener onClickAway={this.handleClose}>
                                    <MenuList>
                                        {languages.map(lang => (
                                            <MenuItem onClick={() => { this.handleClick(lang.code) }}>{lang.name}</MenuItem>
                                        ))}
                                    </MenuList>
                                </ClickAwayListener>
                            </Paper>
                        </Grow>
                    )}
                </Popper>
            </div>
        );
    }
}

MenuLanguage.propTypes = {
    classes: PropTypes.object,
};



export default withCookies(withRouter(withLocalize(MenuLanguage)));
